<template>
    
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
 
      <el-card>
        <!-- <div style="display: flex; justify-content: space-between; align-items: flex-start; flex-wrap: wrap;">

        <el-form-item :label="$t('material.material', { msg: 'material.material' })" prop="material" style="flex: 1; margin-right: 0px;">
          <el-select v-model="materialList.id" :placeholder="$t('purchase.tomaterial', { msg: 'purchase.tomaterial' })" @change="handleselectmaterial(materialList.id)">
            <el-option
              v-for="item in materialList"
              :key="item.id"
              :label="item.material"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item :label="$t('material.materialprice', { msg: 'material.materialprice' })" prop="materialprice" style="flex: 1; margin-right: 0px;">
          <el-input v-model="ruleForm.materialprice" placeholder="" :disabled="true"></el-input>
        </el-form-item>

        <el-form-item :label="$t('material.unit', { msg: 'material.unit' })" prop="materialunit" style="flex: 1; margin-right: 0px;">
          <el-input v-model="ruleForm.materialunit" placeholder="" :disabled="true"></el-input>
        </el-form-item>

        <el-form-item :label="$t('purchase.materialMultip', { msg: 'purchase.materialMultip' })" prop="materialWeight" style="flex: 1;">
          <el-input v-model="ruleForm.materialWeight" :placeholder="$t('purchase.tomMultiplier', { msg: 'purchase.tomMultiplier' })"></el-input>
        </el-form-item>
        
      </div> -->

      <div style="display: flex; justify-content: space-between; align-items: flex-start; flex-wrap: wrap;">
      <div
      v-for="(materialdto, index) in ruleForm.materialDTO"
      :key="materialdto.key"
      style="display: flex; flex-wrap: wrap; margin-bottom: 1px;"
    >
      <el-form-item
      :label="$t('material.material', { msg: 'material.material' }) + (index+1)"
      :prop="'materialDTO.' + index + '.id'"
      :rules="{
          required: true, message: this.$t('purchase.tomaterial', { msg: 'purchase.tomaterial' }), trigger: 'change'
        }" 
        style="flex: 1;"
      >
        <el-select v-model="materialdto.id" :placeholder="$t('purchase.tomaterial', { msg: 'purchase.tomaterial' })" @change="handleselectmaterialdto(materialdto)">
          <el-option
              v-for="item in materialList"
              :key="item.id"
              :label="item.material"
              :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item
      :label="$t('material.materialprice', { msg: 'material.materialprice' })"
        label-width="150px"
        style="flex: 1;"
      >
        <el-input v-model="materialdto.materialPrice" :disabled="true"></el-input>
      </el-form-item>

      <el-form-item
      :label="$t('material.unit', { msg: 'material.unit' })"
        style="flex: 1;"
      >
        <el-input v-model="materialdto.unit" :disabled="true"></el-input>
      </el-form-item>

      <el-form-item
      :label="$t('purchase.lossFactor', { msg: 'purchase.lossFactor' })"
      :prop="'materialDTO.' + index + '.lossFactor'"
      :rules="{
          required: true, message: this.$t('purchase.inlnotnull', { msg: 'purchase.inlnotnull' }), trigger: 'blur'
        }" 
        style="flex: 1;"
      >
      <el-tooltip class="item" effect="dark" content="没有损耗是1,有损耗大于1,如1.2" placement="top-start">
        <el-input v-model="materialdto.lossFactor" :placeholder="$t('purchase.inputloss', { msg: 'purchase.inputloss' })"></el-input>
      </el-tooltip>
      </el-form-item>

      <el-form-item
       :label="$t('purchase.materialMultip', { msg: 'purchase.materialMultip' })"
       :prop="'materialDTO.' + index + '.materialWeight'"
       :rules="{
          required: true, message: this.$t('purchase.inwnotnull', { msg: 'purchase.inwnotnull' }), trigger: 'blur'
        }"
        style="flex: 1;"
      >
        <el-input v-model="materialdto.materialWeight" :placeholder="$t('purchase.incmult', { msg: 'purchase.incmult' })"></el-input>
      </el-form-item>

      <div style="justify-content: center; margin-left: 1px;">
        <!-- <el-button>计算</el-button> -->
        <el-button
          v-if="index > 0"
          @click.prevent="removeMaterial(materialdto)"
          style="margin-left: 10px;"
        >
          {{ $t('kbReview.delete', { msg: 'kbReview.delete' }) }}
        </el-button>
      </div>
    </div>
    <!-- <el-form-item >
      <el-button @click="addMaterial">{{ $t('craft.addcraft', { msg: 'craft.addcraft' }) }}</el-button> 
      <el-button @click="resetForm('ruleForm')"> {{ $t('kbinfo.reset', { msg: 'kbinfo.reset' }) }}</el-button>
    </el-form-item> -->
     </div>
      
       <div style="text-align: left;">

    <div
      v-for="(domain, index) in ruleForm.domains"
      :key="domain.key"
      style="display: flex; flex-wrap: wrap; margin-bottom: 1px;"
    >
      <el-form-item
        :label="this.$t('purchase.craft', { msg: 'purchase.craft' }) + (index+1)"
        :prop="'domains.' + index + '.id'"
        :rules="{
          required: true, message: this.$t('purchase.craftnotnull', { msg: 'purchase.craftnotnull' }), trigger: 'change'
        }"
        style="flex: 1; margin-right: 1px;"
      >
        <el-select v-model="domain.id" :placeholder="$t('purchase.tocraft', { msg: 'purchase.tocraft' })" @change="handleselectcraft(domain)">
          <el-option
            v-for="item in craftlist"
            :key="item.id"
            :label="item.craftDesc"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item
        :label="$t('craft.craftprice', { msg: 'craft.craftprice' })"
        label-width="150px"
        style="flex: 1; margin-right: 1px;"
      >
        <el-input v-model="domain.craftPrice" :disabled="true"></el-input>
      </el-form-item>

      <el-form-item
        :label="$t('craft.unit', { msg: 'craft.unit' })"
        style="flex: 1; margin-right: 1px;"
      >
        <el-input v-model="domain.unit" :disabled="true"></el-input>
      </el-form-item>

      <el-form-item
        :label="$t('purchase.craftMult', { msg: 'purchase.craftMult' })"
        :prop="'domains.' + index + '.craftFactor'"
        :rules="{
          required: true, message: this.$t('purchase.mmnotnull', { msg: 'purchase.mmnotnull' }), trigger: 'blur'
        }"
        style="flex: 1;"
      >
        <el-input v-model="domain.craftFactor" :placeholder="$t('purchase.incmult', { msg: 'purchase.incmult' })"></el-input>
      </el-form-item>

      <div style="justify-content: center; margin-left: 1px;">
        <el-button
          v-if="index > 0"
          @click.prevent="removeDomain(domain)"
          style="margin-left: 10px;"
        >
          {{ $t('kbReview.delete', { msg: 'kbReview.delete' }) }}
        </el-button>
      </div>
    </div>

  <el-form-item  :label="$t('purchase.manageMultip', { msg: 'purchase.manageMultip' })" prop="manageFeeFactor">
    <el-tooltip class="item" effect="dark" content="按比例输入,如0.05" placement="top-start">
    <el-col :span="5"><el-input v-model="ruleForm.manageFeeFactor"  :placeholder="$t('purchase.inputManage', { msg: 'purchase.inputManage' })"></el-input></el-col> 
    </el-tooltip>
  </el-form-item>
  <el-form-item >
    <el-button type="warning" plain @click="addMaterial">{{ $t('material.addmaterial', { msg: 'material.addmaterial' }) }}</el-button> 
    <el-button type="warning" plain @click="addDomain">{{ $t('craft.addcraft', { msg: 'craft.addcraft' }) }}</el-button> 
    <el-button @click="resetForm('ruleForm')">{{ $t('kbinfo.reset', { msg: 'kbinfo.reset' }) }}</el-button>
    <el-button type="success" @click="submitForm('ruleForm')">{{ $t('purchase.totalcost', { msg: 'purchase.totalcost' }) }}</el-button>
  </el-form-item>
   </div>

   <div style="text-align: left;">
  <el-form-item>
    <el-descriptions class="margin-top" :title="$t('purchase.feeList', { msg: 'purchase.feeList' })" :column="3" border>
    <el-descriptions-item :label="$t('purchase.cmFee', { msg: 'purchase.cmFee' })" width="100px"> <span style="font-weight: bold;">{{ totalMC }}</span></el-descriptions-item>
    <el-descriptions-item :label="$t('purchase.manageFee', { msg: 'purchase.manageFee' })" width="100px"> <span style="font-weight: bold;">{{ manageFee }}</span></el-descriptions-item>
    <el-descriptions-item :label="$t('purchase.totalcost', { msg: 'purchase.totalcost' })" width="100px"> <span style="font-weight: bold;">{{ countprice }}</span></el-descriptions-item>
  </el-descriptions>
    <!-- <el-col :span="5"><el-input v-model="countprice" placeholder=""></el-input> </el-col> -->
  </el-form-item>
    </div>
   </el-card>

</el-form>

<el-card>

<div class="button-export" v-if="pcbHistory && pcbHistory.length > 0">
    <el-button type="primary" icon="el-icon-upload2" size="mini" @click="exporthostory" round>
     {{ $t('purchase.exportpcb', { msg: 'purchase.exportpcb' }) }}
    </el-button>
  </div>

<div class="block">
  <el-timeline reverse="true">
    <el-timeline-item
      placement="top"
      v-for="(pcb, index) in pcbHistory"
      :key="index"
      :timestamp="pcb.insertTime"> 
      <el-card>
        <div class="content-container">
          <h4>{{ $t('purchase.pcblist', { msg: 'purchase.pcblist' }) }}</h4>
          <el-button icon="el-icon-delete" size="mini" @click="deletePcb(pcb.id)">{{ $t('kbReview.delete', { msg: 'kbReview.delete' }) }}</el-button>
        </div>
        <p> {{pcb.mathList}}</p>
      </el-card>
    </el-timeline-item>
  </el-timeline>
</div>

</el-card>

</template>
<script>
import { baseUrl_New } from '../../axios/urlconfig';
import { deleteRequest, getRequest, postRequest,postExcelRequest } from '../../axios/axios';
  export default {
    data() {
      return {
        ruleForm: {
          material: '',
          materialprice:'',
          materialunit:'',
          materialWeight: '',
          manageFeeFactor:'',
          materialDTO:[
            {
            id:'',
            material: '',
            materialPrice:'',
            unit:'',
            currencyId: '',
            materialWeight: '',
            lossFactor:'',
            }
          ],
         
          domains: [{
            id:'',
            craftCode: '',
            craftDesc:'',
            craftPrice:'',
            unit:'',
            currencyId:'',
            craftFactor:'',

          }],
         
        },
        labelnull:1,
        totalMC:'',
        manageFee:'',
        countprice:'',
        userId:'',
        pcbHistory:[],
        rules: {
          materialPrice: [
            { required: true, message: '请选择材料', trigger: 'change' }
          ],
          materialWeight: [
            { required: true, message: this.$t('purchase.inmmult', { msg: 'purchase.inmmult' }), trigger: 'blur' }
          ],
          manageFeeFactor:[
          { required: true, message: this.$t('purchase.inputManage', { msg: 'purchase.inputManage' }), trigger: 'blur' }
          ],
            
        },
        craftlist:[
        {
            id: '',
            craftCode: '',
            craftDesc:'',
            craftPrice: '',
            unit:'',
            craftFactor: null
        }
        ],
        materialList:[

        ],


      };
    },

    created(){
      this.getCraftAll();
      this.getMaterialAll();
      this.getPCBHistory();
    },
    methods: {
      // submitForm(formName) {
      //   this.$refs[formName].validate((valid) => {
      //     if (valid) {

      //       postRequest(baseUrl_New + '/craft/math', {
      //         materialPrice: this.ruleForm.materialprice,
      //         materialWeight: this.ruleForm.materialWeight,
      //         "processDTOS": [
      //         {           
      //           craftPrice: this.ruleForm.domains.craftPrice,
      //           craftFactor: this.ruleForm.domains.craftFactor,
                
      //         }
      //       ]
      //       }).then(resp => {
      //        this.countprice  = resp.data.countPrice;
             
      //       }).catch(err => {
      //         this.$message.error("计算失败");
      //       })
          
            
      //     } else {
      //       console.log('error submit!!');
      //       return false;
      //     }
      //   });
      // },
      submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const materialDTOS = this.ruleForm.materialDTO.map(materialdto =>({
            material: materialdto.material,
            materialPrice: materialdto.materialPrice,
            currencyId: materialdto.currencyId,
            materialWeight: materialdto.materialWeight,
            lossFactor: materialdto.lossFactor,
          }));
          const processDTOS = this.ruleForm.domains.map(domain => ({
            craftDesc: domain.craftDesc,
            craftPrice: domain.craftPrice,
            currencyId: domain.currencyId,
            craftFactor: domain.craftFactor,
           
          }));
          
          postRequest(baseUrl_New + '/craft/math', {  
            userId:sessionStorage.getItem("userid"),       
            manageFeeFactor: this.ruleForm.manageFeeFactor,
            materialDTOS: materialDTOS,
            processDTOS: processDTOS
          }).then(resp => {
            this.totalMC = resp.data.data.total;
            this.manageFee = resp.data.data.manageFee;
            this.countprice = resp.data.data.countPrice;
            this.getPCBHistory();
          }).catch(err => {
            this.$message.error("计算失败");
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
      resetForm(formName) {
        this.$refs[formName].resetFields();
        this.ruleForm.material = '';
        this.ruleForm.materialprice = '';
        this.ruleForm.materialunit = '';
        this.ruleForm.materialWeight = '';
        this.ruleForm.manageFeeFactor = '';
        this.ruleForm.materialDTO = [{
          id:'',
          material: '',
          materialPrice:'',
          unit:'',
          materialWeight: '',
          lossFactor:'',  
        }],
        this.ruleForm.domains = [{
          id: '',
          craftCode: '',
          craftPrice: '',
          unit: '',
          craftFactor: '',
        }];
        this.materialList.id = '';
        this.countprice = '';
        this.totalMC = '';
        this.manageFee = '';
      },
      removeDomain(item) {
        var index = this.ruleForm.domains.indexOf(item)
        if (index !== -1) {
          this.ruleForm.domains.splice(index, 1)
        }
      },
      addDomain() {
        this.ruleForm.domains.push({
          craftCode: '',
          craftPrice:'',
          craftFactor: '',
          key: Date.now()
        });
      },
      removeMaterial(item) {
        var index = this.ruleForm.materialDTO.indexOf(item)
        if (index !== -1) {
          this.ruleForm.materialDTO.splice(index, 1)
        }
      },
      addMaterial(){
        this.ruleForm.materialDTO.push({
          material: '',
          materialPrice:'',
          unit:'',
          materialWeight: '',
          lossFactor:'',
          key: Date.now()
        });
      },
      getCraftAll(){
          getRequest(baseUrl_New+'/craft/list').then(response=>{
            let resultMap = response;
            this.craftlist=resultMap.list;
          })
        },
        getMaterialAll(){
          getRequest(baseUrl_New+'/material/list').then(response=>{
            let resultMap = response;
            this.materialList=resultMap.list;
          })
        },
        handleselectmaterial(id){
          const selectedmaterial = this.materialList.find(material => material.id === id);
          if (selectedmaterial) {
          this.ruleForm.materialprice = selectedmaterial.materialPrice;
          this.ruleForm.materialunit = selectedmaterial.unit;
         
        }
        },
        handleselectmaterialdto(materialdto){
          const selectedmaterial = this.materialList.find(material => material.id === materialdto.id);
          if (selectedmaterial) {
            materialdto.material = selectedmaterial.material;
            materialdto.materialPrice = selectedmaterial.materialPrice;
            materialdto.unit = selectedmaterial.unit;
            materialdto.currencyId =selectedmaterial.currencyId;
         
        }
        },
        handleselectcraft(domain){
          const selectedCraft = this.craftlist.find(craft => craft.id ===domain.id);
        if (selectedCraft) {
          domain.craftDesc = selectedCraft.craftDesc;
          domain.craftPrice = selectedCraft.craftPrice;
          domain.unit = selectedCraft.unit;
          domain.currencyId =selectedCraft.currencyId;
         
        }
        },
        getPCBHistory(){
          this.userId = sessionStorage.getItem("userid");
          getRequest(baseUrl_New+'/craft/history/'+ this.userId ).then(response=>{
          //获得服务器端回传的map对象
            this.pcbHistory = response.list;
        })
        },
        deletePcb(id){
        this.$confirm( this.$t('purchase.deleteHtips', { msg: 'purchase.deleteHtips' }), this.$t('issue.tips', { msg: 'issue.tips' }),{
            confirmButtonText: this.$t('addType.confirm', { msg: 'addType.comfirm' }),
            cancelButtonText: this.$t('addType.cancel', { msg: 'addType.cancel' }),
            cancelButtonClass: 'btn-custom-cancel',
            type: 'warning'
        }).then(() => {
            deleteRequest(baseUrl_New + `/craft/remove/${id}`)
            .then(response=>{
            this.$message.success(this.$t('issue.deleteS', { msg: 'issue.deleteS' }))
            this.getPCBHistory();
                                 
            })
        })
        },
        exporthostory(){ //导出excel
          postExcelRequest(baseUrl_New + '/craft/export?userId='+this.userId).then(resp=>{
              // console.log(resp);
              const url = window.URL.createObjectURL(new Blob([resp]));
              const a = document.createElement('a');
              a.href = url;
              a.download = 'pcb.xlsx';
              document.body.appendChild(a);
              a.click();
              window.URL.revokeObjectURL(url);
              document.body.removeChild(a);
              this.$message.success("successful !");
            }).catch(err => {
              this.$message.error(err);
            });
        },





    }
  }
</script>

<style scoped>
.content-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.title {
  margin: 0;
}

.delete-button {
  margin-left: 10px;
}
.el-timeline {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.button-export {
  display: flex;
  justify-content: flex-start;
  padding-left: 25px; /* 设置左边的内边距 */
}

.item {
      margin: 4px;
    }
</style>